<template>
  <div>
    <span v-translate>
      Tell us a little more about yourself to get your Job Recommendations.
    </span>
    <div class="file is-centered robot">
      <robot-illustration></robot-illustration>
    </div>
    <div class="button-block">
      <icon-button class="button is-secondary is-rounded paragraph-m" @click="$emit('click')">
        <svg-icon slot="icon" name="plus" width="16" height="16"></svg-icon>
        <div v-translate slot="text">Get job recommendations</div>
      </icon-button>
    </div>
  </div>
</template>

<script>

import 'top20common/distribution/icons/plus';

import RobotIllustration from 'top20common/components/illustrations/RobotIllustration';

import IconButton from '@/common/IconButton';

export default {
  components: {RobotIllustration, IconButton}
};
</script>

<style lang="scss" scoped>
/deep/ .button-block {
  text-align: right;
  padding-top: 28px;

  a {
    display: inline-flex;

    svg {
      stroke: var(--white);
    }
  }
}

.robot svg {
  max-height: 163px;
  margin-top: 20px;
}
</style>
